export const desktopBreakpointWidth = 1024
export const desktopBreakpoint = `1024px`

export const mobileVW = px => {
  return `${(px / 375) * 100}vw`
}

export const desktopVW = (px, viewport = 1920) => `${(px / viewport) * 100}vw`
export const letterSpacing = space => {
  return `${(space / 1000) * 1}em`
}

export const font = {
  nib: 'Nib',
  marby: 'Marby',
  trio: 'Trio',
}

export const colors = {
  orange: '#FF7002',
  softOrange: '#FDA375',
  purple: '#C8D5F0',
  pink: '#E5CAED',
  green: '#254F40',
  ligthGreen: '#297258',
  babyBlue: '#E3EDFF',
  beige: '#F9F7EF',
}

export const headerHeigth = {
  mobile: '13.112vw',
  desktop: '4.075vw',
}
